module.exports = __webpack_public_path__ + "static/media/colheitadeira.93f696ab.svg";